import './component.scss'


// WEBPACK FOOTER //
// ./app/components/what_we_are_learning_content/component.js